import React from 'react';
import PropTypes from 'prop-types';
import LoadableHOC from '../LoadableHOC';
import NumberInput from '../formComponents/NumberInput';

const LoadableNumberInput = (props) => {
  const onChange = (name, value) => {
    props.onChange(name,
      value);
  };

  return (<NumberInput {...props} onChange={onChange} />);
};

LoadableNumberInput.PropTypes = {
  onChange:PropTypes.func,
};

export default LoadableHOC(LoadableNumberInput);
